import {
  Box,
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  IconButton,
  LinearProgress,
  MenuItem,
  TextField,
  Typography,
} from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import SaveIcon from "@mui/icons-material/Save";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import RemoveCircleOutlineIcon from "@mui/icons-material/RemoveCircleOutline";
import { useEffect, useState } from "react";
import AddIcon from "@mui/icons-material/Add";
import { createFuente, getFuentes, saveIndice, getTiposValor } from "../../../services/IndiceService";

const initialState = {
  codigo: "",
  descripcion: "",
  tipo_valor_id: null,
  tipo_fecha: "MENSUAL",
  valor: "",
  fecha: "",
  vigencia_desde: "",
  vigencia_hasta: "",
  referencia: "",
  resolucion: "",
  fuente_id: "",
  habilitado: true,
};

const initialNuevaFuente = {
  nombre: "",
  url: "",
};

const nameItemText = "Indice";
const itemGender = "M";

//
// #############################################################################
//
const IndiceDialog = ({ onSave, onClose, itemCrud, actionCrud, setMessage, setShowMessage }) => {
  const [itemCrudLocal, setItemCrudLocal] = useState(initialState);
  const [isDoingSomething, setIsDoingSomething] = useState(false);
  const [fuentes, setFuentes] = useState([]);
  const [isLoadingFuentes, setIsLoadingFuentes] = useState(false);
  const [tiposValor, setTiposValor] = useState([]);
  const [isLoadingTiporValor, setIsLoadingTiporValor] = useState(false);
  const [openNuevaFuenteDialog, setOpenNuevaFuenteDialog] = useState(false);
  const [nuevaFuente, setNuevaFuente] = useState(initialNuevaFuente);

  useEffect(() => {
    if (actionCrud === "create") {
      setItemCrudLocal(initialState);
      return;
    }

    setItemCrudLocal({
      ...initialState,
      ...itemCrud,
      fecha: itemCrud?.fecha || "",
      vigencia_desde: itemCrud?.vigencia_desde || "",
      vigencia_hasta: itemCrud?.vigencia_hasta || "",
      valor: itemCrud?.valor ?? "",
      tipo_valor_id: itemCrud?.tipo_valor_id ?? null,
    });
  }, [actionCrud, itemCrud]);

  useEffect(() => {
    if (actionCrud === "create" || actionCrud === "update" || actionCrud === "edit") {
      loadFuentes();
      loadTiposValor();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [actionCrud]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setItemCrudLocal((prev) => ({ ...prev, [name]: value }));
  };

  const handleSave = () => {
    if (actionCrud === "disable" || actionCrud === "enable") {
      save();
      return;
    }

    if (!itemCrudLocal.codigo?.trim()) {
      setMessage({ severity: "error", messageText: "Debes ingresar un código" });
      setShowMessage(true);
      return;
    }
    if (!itemCrudLocal.descripcion?.trim()) {
      setMessage({ severity: "error", messageText: "Debes ingresar una descripción" });
      setShowMessage(true);
      return;
    }
    if (!itemCrudLocal.tipo_valor_id) {
      setMessage({ severity: "error", messageText: "Debes seleccionar tipo de valor" });
      setShowMessage(true);
      return;
    }

    if (!itemCrudLocal.tipo_fecha?.trim()) {
      setMessage({ severity: "error", messageText: "Debes ingresar tipo de fecha" });
      setShowMessage(true);
      return;
    }
    if (itemCrudLocal.valor === "" || itemCrudLocal.valor === null) {
      setMessage({ severity: "error", messageText: "Debes ingresar el valor" });
      setShowMessage(true);
      return;
    }

    if (itemCrudLocal.tipo_fecha === "VIGENCIA" && !itemCrudLocal.vigencia_desde) {
      setMessage({ severity: "error", messageText: "Debes ingresar vigencia desde" });
      setShowMessage(true);
      return;
    }

    if (itemCrudLocal.tipo_fecha !== "VIGENCIA" && !itemCrudLocal.fecha) {
      setMessage({ severity: "error", messageText: "Debes ingresar la fecha" });
      setShowMessage(true);
      return;
    }

    save();
  };

  const loadFuentes = async () => {
    setIsLoadingFuentes(true);
    const response = await getFuentes({});
    setIsLoadingFuentes(false);
    if (response.ok) {
      setFuentes(response?.data?.data || []);
    }
  };

  const handleOpenNuevaFuente = () => {
    setNuevaFuente(initialNuevaFuente);
    setOpenNuevaFuenteDialog(true);
  };

  const handleNuevaFuenteChange = (e) => {
    const { name, value } = e.target;
    setNuevaFuente((prev) => ({ ...prev, [name]: value }));
  };

  const handleCrearFuente = async () => {
    if (!nuevaFuente.nombre.trim()) {
      setMessage({
        severity: "error",
        messageText: "Debes ingresar el nombre de la fuente",
      });
      setShowMessage(true);
      return;
    }

    const response = await createFuente({
      nombre: nuevaFuente.nombre.trim(),
      url: nuevaFuente.url.trim(),
    });

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);

    if (!response.ok) {
      return;
    }

    const nueva = response?.data?.data;
    if (nueva?.id) {
      setFuentes((prev) => {
        const exists = prev.some((f) => String(f.id) === String(nueva.id));
        if (exists) return prev;
        return [...prev, nueva].sort((a, b) => (a.nombre || "").localeCompare(b.nombre || ""));
      });
      setItemCrudLocal((prev) => ({ ...prev, fuente_id: String(nueva.id) }));
    }
    setOpenNuevaFuenteDialog(false);
  };

  const loadTiposValor = async () => {
    setIsLoadingTiporValor(true);
    const response = await getTiposValor({});
    setIsLoadingTiporValor(false);
    if (response.ok) {
      setTiposValor(response?.data?.data || []);
    }
  };

  const save = async () => {
    const payload = {
      id: itemCrudLocal.id,
      codigo: itemCrudLocal.codigo?.trim(),
      descripcion: itemCrudLocal.descripcion?.trim(),
      tipo_valor: itemCrudLocal.tipo_valor_id ? String(itemCrudLocal.tipo_valor_id) : "",
      tipo_fecha: itemCrudLocal.tipo_fecha?.trim(),
      referencia: itemCrudLocal.referencia?.trim(),
      resolucion: itemCrudLocal.resolucion?.trim(),
      fuente_id: itemCrudLocal.fuente_id ? String(itemCrudLocal.fuente_id) : null,
      tipo_valor_id: itemCrudLocal.tipo_valor_id ? String(itemCrudLocal.tipo_valor_id) : null,
      fecha: itemCrudLocal.fecha || null,
      vigencia_desde: itemCrudLocal.vigencia_desde || null,
      vigencia_hasta: itemCrudLocal.vigencia_hasta || null,
      valor: Number(itemCrudLocal.valor),
      habilitado: itemCrudLocal.habilitado,
      usernameUsuarioActualiza: localStorage.getItem("emailUsuario"),
    };

    setIsDoingSomething(true);
    const response = await saveIndice(actionCrud === "edit" ? "update" : actionCrud, payload);
    setIsDoingSomething(false);

    if (response.ok) {
      onSave();
    }

    setMessage({
      messageText: response.messageText,
      severity: response.messageSeverity,
    });
    setShowMessage(true);
  };

  return (
    <>
      <Dialog
        open={true}
        onClose={onClose}
        maxWidth="md"
        fullWidth={true}
        scroll="paper"
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title" textAlign={{ xs: "center", sm: "center" }}>
          {actionCrud === "create"
            ? itemGender === "M"
              ? "Nuevo"
              : "Nueva"
            : actionCrud === "update"
              ? "Nuevo valor para"
              : actionCrud === "edit"
                ? "Editando"
                : actionCrud === "enable"
                  ? "Habilitando"
                  : "Deshabilitando"}{" "}
          {nameItemText}
          <IconButton
            aria-label="close"
            onClick={onClose}
            sx={{
              position: "absolute",
              right: 8,
              top: 8,
              color: (theme) => theme.palette.grey[500],
            }}
          >
            <CloseIcon />
          </IconButton>
        </DialogTitle>

        {isDoingSomething && <LinearProgress />}

        <DialogContent dividers>
          {(actionCrud === "create" || actionCrud === "update" || actionCrud === "edit") && (
            <Box sx={{ m: 1, p: 1 }}>
              <TextField
                variant="outlined"
                size="small"
                name="codigo"
                label="Código"
                value={itemCrudLocal.codigo}
                onChange={handleChange}
                disabled={actionCrud === "update"}
                sx={{ width: "100%", pb: 1 }}
                autoFocus={true}
                inputProps={{ maxLength: 80 }}
              />

              <TextField
                variant="outlined"
                size="small"
                name="descripcion"
                label="Descripción"
                value={itemCrudLocal.descripcion}
                onChange={handleChange}
                disabled={actionCrud === "update"}
                sx={{ width: "100%", pb: 1 }}
                inputProps={{ maxLength: 120 }}
              />

              <Grid container spacing={2} sx={{ pb: 1 }}>
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="outlined"
                    size="small"
                    name="tipo_valor_id"
                    label="Tipo valor"
                    value={itemCrudLocal.tipo_valor_id || ""}
                    onChange={handleChange}
                    disabled={actionCrud === "update"}
                    sx={{ width: "100%" }}
                    select
                    helperText={isLoadingTiporValor ? "Cargando tipos de valor..." : ""}
                  >
                    <MenuItem value="">Sin seleccionar</MenuItem>
                    {tiposValor.map((tipoValor) => (
                      <MenuItem key={tipoValor.id} value={tipoValor.id}>{tipoValor.descripcion}</MenuItem>
                    ))}
                  </TextField>

                </Grid>
                <Grid item xs={12} sm={6}>
                  <TextField
                    variant="outlined"
                    size="small"
                    name="tipo_fecha"
                    label="Tipo fecha"
                    value={itemCrudLocal.tipo_fecha}
                    onChange={handleChange}
                    disabled={actionCrud === "update"}
                    select
                    sx={{ width: "100%" }}
                  >
                    <MenuItem value="DIARIO">DIARIO</MenuItem>
                    <MenuItem value="MENSUAL">MENSUAL</MenuItem>
                    <MenuItem value="VIGENCIA">VIGENCIA</MenuItem>
                  </TextField>
                </Grid>
              </Grid>

              <Grid container spacing={2} sx={{ pb: 1 }}>
                <Grid item xs={12} sm={4}>
                  <TextField
                    variant="outlined"
                    size="small"
                    name="valor"
                    label="Valor"
                    type="number"
                    disabled={actionCrud === "edit"}
                    value={itemCrudLocal.valor}
                    onChange={handleChange}
                    onWheel={(e) => e.target.blur()}
                    sx={{ width: "100%" }}
                    inputProps={{ step: "0.0001" }}
                  />
                </Grid>
                {itemCrudLocal.tipo_fecha === "VIGENCIA" ? (
                  <>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        size="small"
                        name="vigencia_desde"
                        label="Vigencia desde"
                        type="date"
                        value={itemCrudLocal.vigencia_desde || ""}
                        onChange={handleChange}
                        disabled={actionCrud === "edit"}
                        sx={{ width: "100%" }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                    <Grid item xs={12} sm={4}>
                      <TextField
                        variant="outlined"
                        size="small"
                        name="vigencia_hasta"
                        label="Vigencia hasta"
                        type="date"
                        value={itemCrudLocal.vigencia_hasta || ""}
                        onChange={handleChange}
                        disabled={actionCrud === "edit"}
                        sx={{ width: "100%" }}
                        InputLabelProps={{ shrink: true }}
                      />
                    </Grid>
                  </>
                ) : (
                  <Grid item xs={12} sm={8}>
                    <TextField
                      variant="outlined"
                      size="small"
                      name="fecha"
                      label="Fecha"
                      type="date"
                      disabled={actionCrud === "edit"}
                      value={itemCrudLocal.fecha || ""}
                      onChange={handleChange}
                      sx={{ width: "100%" }}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                )}
              </Grid>

              <TextField
                variant="outlined"
                size="small"
                name="referencia"
                label="Referencia"
                value={itemCrudLocal.referencia || ""}
                onChange={handleChange}
                sx={{ width: "100%", pb: 1 }}
              />

              <TextField
                variant="outlined"
                size="small"
                name="resolucion"
                label="Resolución"
                value={itemCrudLocal.resolucion || ""}
                onChange={handleChange}
                sx={{ width: "100%", pb: 1 }}
              />

              <Grid container spacing={2}>
                <Grid item xs={12}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                    <TextField
                      variant="outlined"
                      size="small"
                      name="fuente_id"
                      label="Fuente"
                      value={itemCrudLocal.fuente_id || ""}
                      onChange={handleChange}
                      sx={{ width: "100%" }}
                      select
                      helperText={isLoadingFuentes ? "Cargando fuentes..." : ""}
                    >
                      <MenuItem value="">Sin fuente</MenuItem>
                      {fuentes.map((fuente) => (
                        <MenuItem key={fuente.id} value={fuente.id}>
                          {fuente.nombre}
                        </MenuItem>
                      ))}
                    </TextField>
                    <IconButton
                      color="primary"
                      aria-label="nueva-fuente"
                      title="Nueva fuente"
                      onClick={handleOpenNuevaFuente}
                      sx={{ mt: -1 }}
                    >
                      <AddIcon />
                    </IconButton>
                  </Box>
                </Grid>
              </Grid>
            </Box>
          )}
          {(actionCrud === "disable" || actionCrud === "enable") && (
            <Box sx={{ p: 1 }}>
              <Typography>
                {actionCrud === "disable"
                  ? "¿Deseas deshabilitar este índice?"
                  : "¿Deseas habilitar este índice?"}
              </Typography>
              <Typography variant="body2" color="text.secondary">
                {itemCrudLocal.codigo} - {itemCrudLocal.descripcion}
              </Typography>
            </Box>
          )}

          {(actionCrud !== "disable" && actionCrud !== "enable") && (
            <Box sx={{ p: 1, color: "SlateGrey" }}>
              <Typography variant="body2" component="div" gutterBottom>
                Creado: {itemCrudLocal.fecha_creacion || "-"}
              </Typography>
              <Typography variant="body2" component="div" gutterBottom>
                Última actualización: {itemCrudLocal.fecha_actualizacion || "-"}
              </Typography>
            </Box>
          )}

          <Box sx={{ textAlign: "right" }}>
            <Button sx={{ mr: 1 }} variant="outlined" onClick={onClose} startIcon={<CloseIcon />}>
              Cancelar
            </Button>
            <Button
              sx={{ mr: 1 }}
              variant="contained"
              onClick={handleSave}
              startIcon={
                actionCrud === "disable" ? (
                  <RemoveCircleOutlineIcon />
                ) : actionCrud === "enable" ? (
                  <AddCircleOutlineIcon />
                ) : (
                  <SaveIcon />
                )
              }
            >
              {actionCrud === "disable"
                ? "Deshabilitar"
                : actionCrud === "enable"
                  ? "Habilitar"
                  : "Guardar"}
            </Button>
          </Box>
        </DialogContent>
      </Dialog >
      <Dialog
        open={openNuevaFuenteDialog}
        onClose={() => setOpenNuevaFuenteDialog(false)}
        maxWidth="sm"
        fullWidth
      >
        <DialogTitle>Nueva fuente</DialogTitle>
        <DialogContent dividers>
          <TextField
            variant="outlined"
            size="small"
            name="nombre"
            label="Nombre"
            value={nuevaFuente.nombre}
            onChange={handleNuevaFuenteChange}
            sx={{ width: "100%", pb: 2, pt: 1 }}
          />
          <TextField
            variant="outlined"
            size="small"
            name="url"
            label="URL"
            value={nuevaFuente.url}
            onChange={handleNuevaFuenteChange}
            sx={{ width: "100%" }}
          />
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" onClick={() => setOpenNuevaFuenteDialog(false)}>
            Cancelar
          </Button>
          <Button variant="contained" onClick={handleCrearFuente}>
            Guardar fuente
          </Button>
        </DialogActions>
      </Dialog>
    </>
  );
};

export default IndiceDialog;
